<template>
    <div class="auth-wrapper auth-v1">
        <div class="row w-100">
            <div class="col-md-4 col-lg-4 offset-md-4 offset-lg-4">
                <b-card class="mb-0">
                    <b-link class="brand-logo">
                        <vuexy-logo />
                        <img
                            :src="logo"
                            style="max-width: 160px"
                        >
                    </b-link>

                    <h4 class="text-center">
                        {{ $t('Page(MFA):Component(Text):method-selection-label') }}
                    </h4>
                    <p class="pt-1 text-center">
                        {{ $t('Page(MFA):Component(Text):method-selection-instruction') }}
                    </p>

                    <Button
                        v-for="method in methods"
                        :key="method.type"
                        class="btn-block mb-1"
                        @click="selectMethod(method.type)"
                    >
                        {{ methodLabel(method.type) }}: {{ contact(method) }}
                    </Button>

                    <div class="text-center pt-1">
                        <a
                            class="text-primary text-decoration-underline"
                            @click="backToLogin"
                        >{{ $t('Page(MFA):Component(Link):back-to-login') }}</a>
                    </div>
                </b-card>

                <div class="text-center mt-1">
                    <PrivacyPolicyLink />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { Button } from '@core/components/common'
import { BCard, BLink } from 'bootstrap-vue'
import PrivacyPolicyLink from '@core/components/common/PrivacyPolicyLink.vue'
import useJwt from '@/auth/jwt/useJwt'
import { clearMfaState, getMfaState, selectMfaMethod } from '@/auth/mfa'
import { $themeConfig } from '@themeConfig'

export default {
    components: {
        BCard,
        BLink,
        Button,
        PrivacyPolicyLink,
        VuexyLogo,
    },
    data() {
        return {
            methods: [],
            logo: $themeConfig.app.brandingLogo,
        }
    },
    created() {
        const state = getMfaState()

        if (!state || !useJwt.hasToken() || !state.methods || state.methods.length === 0) {
            this.redirectToLogin()
            return
        }

        if (state.methods.length === 1) {
            this.$router.replace({ name: `mfa-${state.methods[0].type}` })
            return
        }

        this.methods = state.methods
    },
    methods: {
        methodLabel(type) {
            return this.$t(`Page(MFA):Component(Text):method-${type}`)
        },
        contact(method) {
            return method.type === 'email' ? method.details.email : method.details.phone
        },
        selectMethod(type) {
            selectMfaMethod(type)
            this.$router.push({ name: `mfa-${type}` })
        },
        backToLogin() {
            clearMfaState()
            useJwt.clear()
            this.$router.push({ name: 'auth-login' })
        },
        redirectToLogin() {
            clearMfaState()
            useJwt.clear()
            this.$router.replace({ name: 'auth-login' })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
